import RightStorage from '../storage/right-storage';

export default function reducer(state = RightStorage, action) {
  switch (action.type) {
    case 'SET_CURRENT_RIGHT': {
      let newState = { ...state };
      newState.setCurrentRight(action.payload)
      return newState;
    }
    default:
      return state
  }
}
